import React from "react"

import Image, { type DashboardImageProps } from "~components/shared/image"
import IconLogoImage from "~assets/images/logos/mb-logo-small.png"

export default function IconLogo(props: DashboardImageProps) {
    return <Image src={IconLogoImage} alt="mallardbay-icon-logo" {...props} />
}
